import { getUserRole } from 'dashboard/helper/permissionsHelper';

export const getters = {
  getTeams($state) {
    return Object.values($state.records).sort((a, b) => a.id - b.id);
  },
  getTeamById: $state => id => {
    return (
      Object.values($state.records).find(record => record.id === Number(id)) ||
      {}
    );
  },
  getMyTeams($state, $getters) {
    return $getters.getTeams.filter(team => {
      const { is_member: isMember } = team;
      return isMember;
    });
  },
  // Teams the current user may assign conversations to.
  // Administrators can assign any account team; agents only their memberships.
  getAssignableTeams($state, $getters, _rootState, rootGetters) {
    const currentUser = rootGetters.getCurrentUser || {};
    const currentAccountId = rootGetters.getCurrentAccountId;
    const role = getUserRole(currentUser, currentAccountId);

    if (role === 'administrator') {
      return $getters.getTeams;
    }

    return $getters.getMyTeams;
  },
  getLedTeams($state, $getters) {
    return $getters.getTeams.filter(team => team.is_leader);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getTeam: $state => id => {
    const team = $state.records[id];
    return team || {};
  },
};
